module.exports = __webpack_public_path__ + "assets/8a07710609a4d88ac6bd51bd81d0913e.mp4";